import { Icon, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, cn } from "@nexus/ui"
import { useTranslation } from "react-i18next"
import type { TableDensity } from "../OpportunitiesTable/OpportunitiesTable"

const DENSITIES: { value: TableDensity; icon: "rows-4" | "rows-3" | "rows-2" }[] = [
  { value: "condensed", icon: "rows-4" },
  { value: "regular", icon: "rows-3" },
  { value: "relaxed", icon: "rows-2" },
]

export interface DensityToggleProps {
  value: TableDensity
  onChange: (value: TableDensity) => void
}

export function DensityToggle({ value, onChange }: DensityToggleProps) {
  const { t } = useTranslation()

  return (
    <TooltipProvider delayDuration={400}>
      <div className="inline-flex items-center rounded-md border border-primary/30 shadow-xs dark:border-primary/40">
        {DENSITIES.map((d) => (
          <Tooltip key={d.value}>
            <TooltipTrigger asChild>
              <button
                type="button"
                onClick={() => onChange(d.value)}
                className={cn(
                  "inline-flex h-8 w-8 items-center justify-center text-sm transition-colors first:rounded-l-md last:rounded-r-md",
                  value === d.value
                    ? "bg-primary/10 text-primary dark:bg-primary/20"
                    : "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
                )}
              >
                <Icon name={d.icon} size="xs" color="inherit" />
              </button>
            </TooltipTrigger>
            <TooltipContent>{t(`opportunities.table.density.${d.value}`)}</TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  )
}
